<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">المعاملات المالية للمزود</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">المعاملات المالية للمزود</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <div v-if="checkAccess('providers_transactions_create')" class="row">
          <div class="col text-end">
            <router-link to="/pTransactions/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة معاملة
            </router-link>
          </div>
        </div>
        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم الجوال">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchStatus">
                      <option :value="null">حالة الطلب</option>
                      <option v-for="(val, key) in statusTranslate" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchType">
                      <option :value="null">نوع المعاملة</option>
                      <option
                        v-for="(val, key) in transactionsTypes"
                        :value="key"
                        :key="key"
                      >
                        {{ val }}
                      </option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">المعاملات المالية للمزود</div>
                  <span v-if="countRows > 0"
                    class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                    عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>المزود</th>
                            <th>الجوال</th>
                            <th>القيمة</th>
                            <th>النوع</th>
                            <th>الحالة</th>
                            <th>بتاريخ</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ (row.Provider)? row.Provider.name : 'غير معروف' }}</td>
                            <td>{{ (row.Provider)? row.Provider.mobile : 'غير معروف' }}</td>
                            <td>{{ row.amount }}</td>
                            <td>{{ transactionsTypes[row.transType] }}</td>
                            <td>{{ statusTranslate[row.status] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/pTransactions/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('providers_transactions_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <!-- <button v-if="checkAccess('providers_transactions_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'PTransactionsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      statusTranslate: {},
      transactionsTypes: {},
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchStatus: this.$route.query.status || null,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false,
      countRows: 0,
      searchType: this.$route.query.type || null,
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchName.trim() != '')
        urlQuery.push(`name=${this.searchName.trim()}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchStatus !== null)
        urlQuery.push(`status=${this.searchStatus}`);
      if(this.searchType !== null)
        urlQuery.push(`type=${this.searchType}`);

      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' && this.searchName !== false ? { name: this.searchName } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' && this.searchMobile !== false ? { mobile: this.searchMobile } : {}),
        ...(this.searchStatus !== null && this.searchStatus !== '' && this.searchStatus !== false ? { status: this.searchStatus } : {}),
        ...(this.searchType !== null && this.searchType !== '' && this.searchType !== false ? { type: this.searchType } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/pTransactions/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.statusTranslate = data.transactionsStatus;
        this.transactionsTypes = data.transactionsTypes;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/pTransactions/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchStatus = null;
      this.searchType = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>